import { Map as ImmMap } from 'immutable';
import { CLEAR_FETCH_ERROR, IS_FETCHING, FETCH_ERROR, RECEIVE_BRAND_INFO } from './constants';

export const initialState = new ImmMap({
	isFetching: false,
	fetchError: undefined,
	brandInfo: new ImmMap(),
});

const categoriesReducer = (state = initialState, action) => {
	switch (action.type) {
		case CLEAR_FETCH_ERROR:
			return state.set('fetchError', undefined);
		case IS_FETCHING:
			return state.set('isFetching', action.isFetching);
		case FETCH_ERROR:
			return state.set('fetchError', action.fetchError);
		case RECEIVE_BRAND_INFO: {
			const brandInfo = {
				logo: action.brandInfo.logo,
				topics: action.brandInfo.topics,
				lastFetchTime: action.lastFetchTime,
			};
			return state.set('brandInfo', brandInfo);
		}
		default:
			return state;
	}
};

export default categoriesReducer;
